<template>
  <footer class="text-muted">
    <div class="footer-body" v-if="$store.state.GlobalData.ads">
      <template v-for="ad in $store.state.GlobalData.ads">
        <router-link
          v-if="ad.cat_id === 'footer'"
          :to="'/' + locale + '/info/' + ad.url[locale]"
          :key="ad.id"
          >{{ ad.name[locale] }}</router-link
        >
      </template>
    </div>
    <p class="text-center copyright">
      <span>&copy; {{ copyright }}</span> 2019.
      <small>Все права защищены.</small>
    </p>
  </footer>
</template>

<script>
export default {
  computed: {
    copyright() {
      return window.location.hostname;
    }
  },
  data() {
    return {
      locale: this.$route.params.locale
    };
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  }
};
</script>
